import { useState, useCallback } from 'react';
import { llmService } from '../services/llmService';

const AI_ENABLED = import.meta.env.VITE_AI_ENABLED !== 'false';

const systemInstruction = `Você é um assistente de suporte inteligente para 'CTT FORÇA E AÇÃO' (Centro de Treinamento de Tiro Força e Ação). Sua tarefa é analisar um novo ticket de suporte e gerar uma resposta em JSON.

Formato do JSON de resposta:
{
    "category": "Dúvida Geral" | "Problema com Compra" | "Questão de Pagamento" | "Assessoria Jurídica" | "Serviços CAC" | "Feedback",
    "initialResponse": "Mensagem inicial educada e profissional em português brasileiro para o usuário confirmando o recebimento do assunto do ticket e estabelecendo expectativa de até 24 horas úteis para resposta humana."
}

Responda APENAS com o objeto JSON válido, sem comentários ou formatações markdown markdown adicionais.`;

export const useSupportAI = () => {
    const [analysis, setAnalysis] = useState<{ category: string; initialResponse: string } | null>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const analyzeTicket = useCallback(async (subject: string, message: string) => {
        if (!AI_ENABLED) {
            const errorMsg = "Assistente de IA desativado.";
            setError(errorMsg);
            console.error(errorMsg);
            return null;
        }

        setIsLoading(true);
        setError(null);
        setAnalysis(null);

        const prompt = `
        Assunto do Ticket: "${subject}"
        Mensagem do Usuário: "${message}"
        `;

        try {
            const jsonText = await llmService.sendMessage(
                [{ role: 'user', content: prompt }],
                systemInstruction,
                true // jsonMode
            );

            // Clean json response if models return backticks
            const cleanedJson = jsonText.replace(/```json/g, '').replace(/```/g, '').trim();
            const parsedJson = JSON.parse(cleanedJson);
            setAnalysis(parsedJson);
            return parsedJson;

        } catch (e) {
            console.error("Error analyzing support ticket:", e);
            setError("Ocorreu um erro ao processar a análise da IA. Um ticket padrão será criado.");
            return null;
        } finally {
            setIsLoading(false);
        }
    }, []);

    return { analysis, isLoading, error, analyzeTicket };
};
